import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
import { Analyser } from "./Analyser";
/**
 * The base class for Metering classes.
 */
export var MeterBase = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(MeterBase, _ToneAudioNode);
  function MeterBase() {
    var _this;
    _classCallCheck(this, MeterBase);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MeterBase).call(this, optionsFromArguments(MeterBase.getDefaults(), arguments)));
    _this.name = "MeterBase";
    _this.input = _this.output = _this._analyser = new Analyser({
      context: _this.context,
      size: 256,
      type: "waveform"
    });
    return _this;
  }
  _createClass(MeterBase, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(MeterBase.prototype), "dispose", this).call(this);
      this._analyser.dispose();
      return this;
    }
  }]);
  return MeterBase;
}(ToneAudioNode);